const PostItemStyle = {
  avatar: {
    margin: 0,
    position: 'absolute', 
    top: '10px',
    left: '10px'
  },
  header: {
    padding: '10px 35px 10px 55px',
    marginBottom: '0.3rem',
    lineHeight: '0.5rem'
  },
  header_title: {
    marginBottom: '0.3rem' 
  },
  cardBody: {
    paddingTop: 0
  },
  buttonEdit: {
    position: 'absolute',
    width: '40px',
    right: '0', 
    background: 'transparent',
    color: '#6c757d',
    border: '0px solid'
  }
};


export default PostItemStyle;


// WEBPACK FOOTER //
// ./src/jsStyles/PostItem.styles.js